<template>
  <div :class="bem('')">
    <div :class="bem('titles')">
      <VisionHeading
        tag="h4"
        size="h2"
      >
        <span :class="bem('grey-title')">
          {{ calculatedTitle }}
        </span>
        Worn By You
      </VisionHeading>
    </div>
    <InstagramGrid
      :posts="12"
      :products="[`${calculatedProductId}`]"
      :show-product-title="!props.customisedProduct.isCoreProduct"
      :does-change-customised-product="props.customisedProduct.isCoreProduct"
      @change-customised-product="handleChangeCustomisedProduct"
    />
  </div>
</template>

<script setup lang="ts">
import CustomisedProduct from '~/models/CustomisedProduct'
const bem = useBEM('ProductInstaShop')
const emit = defineEmits(['change-customised-product'])

const props = defineProps({
  customisedProduct: {
    type: CustomisedProduct,
    required: true,
  },
})

const calculatedProductId = computed(() => {
  if (!props.customisedProduct.isCoreProduct) return ''
  if (props.customisedProduct.isLimitedEdition) {
    return props.customisedProduct.product.baseProduct?.id || ''
  }
  return props.customisedProduct.product?.id || ''
})

const calculatedTitle = computed(() => {
  if (!props.customisedProduct.isCoreProduct) return 'SunGod'
  return props.customisedProduct.product.name
})

function handleChangeCustomisedProduct(sku: string) {
  emit('change-customised-product', sku)
}
</script>

<style lang="postcss">
.ProductInstaShop:has(.InstagramGrid--insufficient-posts) {
  @apply hidden;
}

.ProductInstaShop__titles {
  @apply px-[var(--outer-gutter)] my-5;
}

.ProductInstaShop__grey-title {
  @apply text-grey mr-2;
}
</style>
